import { render, staticRenderFns } from "./CadastrarProdutoDialog.vue?vue&type=template&id=25618eb8&"
import script from "./CadastrarProdutoDialog.vue?vue&type=script&lang=js&"
export * from "./CadastrarProdutoDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports